import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import TagsPage from 'flarum/tags/forum/components/TagsPage';
import IndexPage from 'flarum/forum/components/IndexPage';
app.initializers.add('val-ui-tag-rules', () => {
  const STYLE_ID = 'val-ui-tag-rules-style';
  const MOUNT_CLASS = 'val-tag-rules-mount';
  function addStyleOnce() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
.val-tag-rules-mount {
    margin: 0 0 16px;
}

.val-tag-rules {
    padding: 14px 16px 15px;
    border: 1px solid color-mix(in srgb, var(--muted-color) 26%, transparent);
    border-left: 3px solid var(--primary-color);
    border-radius: 8px;
    background: color-mix(in srgb, var(--control-bg) 50%, var(--body-bg) 50%);
    color: var(--text-color);
}

.val-tag-rules-title {
    margin: 0 0 7px;
    color: var(--heading-color);
    font-size: 14px;
    font-weight: 700;
    line-height: 1.3;
}

.val-tag-rules-text {
    margin: 0;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    font-size: 13px;
    line-height: 1.5;
}

@media (max-width: 767.98px) {
    .val-tag-rules-mount {
        margin: 0 8px 14px;
    }

    .val-tag-rules {
        padding: 12px 13px 13px;
        border-radius: 7px;
    }

    .val-tag-rules-title {
        font-size: 13.5px;
    }

    .val-tag-rules-text {
        font-size: 12.5px;
    }
}
`;
    document.head.appendChild(style);
  }
  function tagsForDiscussion(discussion) {
    if (!discussion || typeof discussion.tags !== 'function') {
      return [];
    }
    try {
      const tags = discussion.tags();
      return Array.isArray(tags) ? tags.filter(Boolean) : [];
    } catch (err) {
      return [];
    }
  }
  function rulesForTag(tag) {
    if (!tag || typeof tag.attribute !== 'function') {
      return '';
    }
    try {
      return String(tag.attribute('valRules') || '').trim();
    } catch (err) {
      return '';
    }
  }
  function rulesHtmlForTag(tag) {
    if (!tag || typeof tag.attribute !== 'function') {
      return '';
    }
    try {
      return String(tag.attribute('valRulesHtml') || '').trim();
    } catch (err) {
      return '';
    }
  }
  function rulesTitleForTag(tag) {
    if (!tag || typeof tag.attribute !== 'function') {
      return 'Règles du forum';
    }
    try {
      return String(tag.attribute('valRulesTitle') || '').trim() || 'Règles du forum';
    } catch (err) {
      return 'Règles du forum';
    }
  }

  /*
   * Une discussion peut avoir plusieurs tags.
   * On privilégie le forum le plus précis (sous-tag), puis un tag primaire,
   * puis le premier tag possédant effectivement des règles.
   */
  function ruleTagForDiscussion(discussion) {
    const withRules = tagsForDiscussion(discussion).filter(tag => rulesHtmlForTag(tag));
    if (!withRules.length) {
      return null;
    }
    return withRules.find(tag => {
      try {
        return typeof tag.isChild === 'function' && tag.isChild();
      } catch (err) {
        return false;
      }
    }) || withRules.find(tag => {
      try {
        return typeof tag.isPrimary === 'function' && tag.isPrimary();
      } catch (err) {
        return false;
      }
    }) || withRules[0];
  }
  function removeMount(page) {
    if (!page || !page.element) {
      return;
    }
    page.element.querySelectorAll('.' + MOUNT_CLASS).forEach(node => {
      try {
        m.render(node, null);
      } catch (err) {}
      node.remove();
    });
  }
  function renderRules(page) {
    if (!page || !page.element) {
      return;
    }
    let tag = null;
    const tagParam = m.route.param('tags');
    if (tagParam) {
      tag = app.store.all('tags').find(item => {
        return item.slug() === tagParam || String(item.id()) === String(tagParam);
      });
    }
    if (!tag) {
      removeMount(page);
      return;
    }
    const rulesHtml = rulesHtmlForTag(tag);
    if (!rulesHtml) {
      removeMount(page);
      return;
    }
    let mount = page.element.querySelector('.' + MOUNT_CLASS);
    if (!mount) {
      mount = document.createElement('div');
      mount.className = MOUNT_CLASS;
      const target = page.element.querySelector('.TagPage') || page.element.querySelector('.DiscussionList') || page.element.firstElementChild || page.element;
      target.parentNode.insertBefore(mount, target);
    }
    const title = rulesTitleForTag(tag);
    m.render(mount, m('section.val-tag-rules', {
      'aria-label': title
    }, [m('h2.val-tag-rules-title', title), m('div.val-tag-rules-text', m.trust(rulesHtml))]));
  }
  function scheduleTagRules(page) {
    window.setTimeout(() => {
      renderRules(page);
    }, 0);
  }
  extend(DiscussionPage.prototype, 'oncreate', function () {
    scheduleTagRules(this);
  });
  extend(DiscussionPage.prototype, 'onupdate', function () {
    scheduleTagRules(this);
  });
  extend(DiscussionPage.prototype, 'onremove', function () {
    removeMount(this);
  });

  /*
   * Pages de forums et sous-forums :
   * les règles sont affichées même si le forum ne contient aucune
   * discussion et ne sert que de parent à des sous-forums.
   */
  extend(IndexPage.prototype, 'oncreate', function () {
    scheduleTagRules(this);
  });
  extend(IndexPage.prototype, 'onupdate', function () {
    scheduleTagRules(this);
  });
  extend(IndexPage.prototype, 'onremove', function () {
    removeMount(this);
  });
});